/* =====================================================================
   nt-fx-faq-busca.js: busca nas perguntas da faq (sections/nt-fx-faq.liquid, setting "busca")
   carregado so quando a busca esta ligada. conversa com o <nt-fx-faq> do nt-fx-g4.js sem mexer nele:
   enquanto busca, mostra os dois grupos, tira o corte do "ver todas" e esconde o que nao bate;
   ao limpar (campo vazio, x ou esc) devolve aba, corte e respostas abertas exatamente como estavam.
   ===================================================================== */
(function () {
  if (customElements.get('nt-fx-faq-busca')) return;

  var ATRASO = 160; // espera da digitacao antes de filtrar
  var AVISO = 650; // o leitor de tela so ouve a contagem quando a pessoa para de digitar
  var MINIMO = 2; // letras para comecar a buscar

  var lista = function (x) { return Array.prototype.slice.call(x); };

  // sem acento, minusculo e sem hifen ("wifi" acha "Wi-Fi"); o mapa liga cada letra normalizada a posicao no original
  function normalizar(txt) {
    var t = '';
    var mapa = [];
    for (var i = 0; i < txt.length; i++) {
      var c = txt[i].normalize('NFD').replace(/[̀-ͯ]/g, '').toLowerCase().replace(/[-‐‑]/g, '');
      for (var k = 0; k < c.length; k++) { t += c[k]; mapa.push(i); }
    }
    return { t: t, mapa: mapa };
  }

  // palavras curtas e de ligacao nao contam: "a bateria" busca so bateria, sem acender cada letra a do titulo
  var LIGACAO = { de: 1, da: 1, do: 1, das: 1, dos: 1, em: 1, no: 1, na: 1, nos: 1, nas: 1, um: 1, uma: 1, com: 1, que: 1, se: 1, os: 1, as: 1, ao: 1, por: 1, pra: 1, para: 1 };

  // cada palavra da busca precisa aparecer na pergunta ou na resposta (virgula e pontuacao separam palavras)
  function termosDe(q) {
    var vistos = {};
    return normalizar(q).t.split(/[\s,.;:!?()[\]"'“”‘’\/]+/).filter(function (t) {
      if (!t || t.length < MINIMO || LIGACAO[t] || vistos[t]) return false;
      vistos[t] = true;
      return true;
    });
  }

  function faixas(txt, termos) {
    var n = normalizar(txt);
    var todas = [];
    termos.forEach(function (t) {
      var i = n.t.indexOf(t);
      while (i > -1) {
        todas.push([n.mapa[i], n.mapa[i + t.length - 1] + 1]);
        i = n.t.indexOf(t, i + t.length);
      }
    });
    todas.sort(function (a, b) { return a[0] - b[0]; });
    var juntas = [];
    todas.forEach(function (f) {
      var ult = juntas[juntas.length - 1];
      if (ult && f[0] <= ult[1]) ult[1] = Math.max(ult[1], f[1]);
      else juntas.push(f.slice());
    });
    return juntas;
  }

  // troca o no de texto por texto + <mark> nos trechos achados; devolve quantos trechos marcou
  function marcar(no, termos) {
    var txt = no.nodeValue;
    var fs = faixas(txt, termos);
    if (!fs.length) return 0;
    var frag = document.createDocumentFragment();
    var pos = 0;
    fs.forEach(function (f) {
      if (f[0] > pos) frag.appendChild(document.createTextNode(txt.slice(pos, f[0])));
      var m = document.createElement('mark');
      m.className = 's-faq__marca';
      m.setAttribute('data-faq-marca', '');
      m.textContent = txt.slice(f[0], f[1]);
      frag.appendChild(m);
      pos = f[1];
    });
    if (pos < txt.length) frag.appendChild(document.createTextNode(txt.slice(pos)));
    no.parentNode.replaceChild(frag, no);
    return fs.length;
  }

  function nosDeTexto(el) {
    var w = document.createTreeWalker(el, NodeFilter.SHOW_TEXT);
    var nos = [];
    while (w.nextNode()) nos.push(w.currentNode);
    return nos;
  }

  // quando so a resposta bate: um pedaco dela embaixo da pergunta, com o achado no comeco da linha
  function trecho(txt, termos) {
    var n = normalizar(txt);
    var ini = -1;
    var tam = 0;
    termos.forEach(function (t) {
      var i = n.t.indexOf(t);
      if (i > -1 && (ini < 0 || i < ini)) { ini = i; tam = t.length; }
    });
    if (ini < 0) return null;
    var a = n.mapa[ini];
    var b = n.mapa[ini + tam - 1] + 1;
    var de = Math.max(0, a - 36);
    var ate = Math.min(txt.length, b + 90);
    if (de > 0) {
      var e1 = txt.indexOf(' ', de);
      de = e1 > -1 && e1 < a ? e1 + 1 : a;
    }
    if (ate < txt.length) {
      var e2 = txt.lastIndexOf(' ', ate);
      if (e2 > b) ate = e2;
    }
    var span = document.createElement('span');
    span.className = 's-faq__trecho';
    span.setAttribute('aria-hidden', 'true');
    span.setAttribute('data-faq-extra', '');
    span.appendChild(document.createTextNode((de > 0 ? '…' : '') + txt.slice(de, ate).trim() + (ate < txt.length ? '…' : '')));
    marcar(span.firstChild, termos);
    return span;
  }

  customElements.define(
    'nt-fx-faq-busca',
    class extends HTMLElement {
      connectedCallback() {
        if (this.pronto) return;
        var faq = this.closest('nt-fx-faq');
        var campo = this.querySelector('[data-faq-busca-input]');
        if (!faq || !campo) return;
        this.pronto = true;
        this.faq = faq;
        this.campo = campo;
        this.x = this.querySelector('[data-faq-busca-x]');
        this.linha = this.querySelector('[data-faq-busca-linha]');
        this.aviso = this.querySelector('[data-faq-busca-aviso]');
        this.vazio = faq.querySelector('[data-faq-busca-vazio]');
        this.termoVazio = faq.querySelector('[data-faq-busca-termo]');
        this.barra = faq.querySelector('[data-faq-abas]');
        this.paineis = lista(faq.querySelectorAll('[data-faq-painel]'));
        this.rotulos = this.paineis.map(function (p) {
          var h = p.querySelector('[data-faq-grupo-titulo]');
          return h ? h.textContent.trim() : '';
        });
        this.itens = lista(faq.querySelectorAll('.s-faq__item')).map(function (d) {
          var texto = d.querySelector('.s-faq__texto');
          var resp = d.querySelector('.s-faq__a');
          var titulo = texto ? texto.textContent : '';
          var respTxt = resp ? nosDeTexto(resp).map(function (n) { return n.nodeValue; }).join(' ').replace(/\s+/g, ' ').trim() : '';
          return {
            d: d,
            texto: texto,
            resp: resp,
            titulo: titulo,
            respTxt: respTxt,
            tituloN: normalizar(titulo).t,
            respN: normalizar(respTxt).t,
            painel: d.closest('[data-faq-painel]'),
            lista: d.parentNode
          };
        }).filter(function (it) { return it.texto && it.resp; });
        this.estado = null;
        this.hidden = false;

        campo.addEventListener('input', this.agendar.bind(this));
        campo.addEventListener('keydown', function (e) {
          if (e.key === 'Escape' && campo.value) { e.preventDefault(); this.limpar(true); }
          else if (e.key === 'Enter') { e.preventDefault(); this.agora(); }
        }.bind(this));
        if (this.x) this.x.addEventListener('click', this.limpar.bind(this, true));
        lista(faq.querySelectorAll('[data-faq-busca-limpa]')).forEach(function (b) {
          b.addEventListener('click', this.limpar.bind(this, true));
        }, this);

        // aba escolhida durante a busca: a busca sai primeiro (fase de captura) e o nt-fx-faq troca a aba como sempre
        if (this.barra) {
          var sair = function (e) {
            if (!this.estado || !e.target.closest('[data-faq-aba]')) return;
            if (e.type === 'keydown' && !/^(ArrowLeft|ArrowRight|Home|End)$/.test(e.key)) return;
            this.limpar(false);
          }.bind(this);
          this.barra.addEventListener('click', sair, true);
          this.barra.addEventListener('keydown', sair, true);
        }
        // editor de temas: escolher uma pergunta durante a busca devolve a lista antes do nt-fx-faq procurar o bloco
        this.aoEscolher = function () { if (this.estado) this.limpar(false); }.bind(this);
        document.addEventListener('shopify:block:select', this.aoEscolher, true);
      }

      disconnectedCallback() {
        clearTimeout(this.t);
        clearTimeout(this.ta);
        if (this.aoEscolher) document.removeEventListener('shopify:block:select', this.aoEscolher, true);
      }

      agendar() {
        if (this.x) this.x.hidden = !this.campo.value;
        clearTimeout(this.t);
        this.t = setTimeout(this.agora.bind(this), ATRASO);
      }

      agora() {
        clearTimeout(this.t);
        if (this.x) this.x.hidden = !this.campo.value;
        var termos = termosDe(this.campo.value);
        if (!termos.length) { this.sair(); return; }
        this.entrar();
        this.filtrar(termos);
      }

      limpar(foco) {
        clearTimeout(this.t);
        this.campo.value = '';
        if (this.x) this.x.hidden = true;
        this.sair();
        if (foco) this.campo.focus();
      }

      // guarda o estado de antes da busca: aba (paineis escondidos), corte do "ver todas" e respostas abertas
      entrar() {
        if (this.estado) return;
        var abas = this.barra && !this.barra.hidden;
        var visiveis = this.paineis.filter(function (p) { return !p.hidden; });
        this.estado = {
          ativo: abas && visiveis.length === 1 ? visiveis[0] : null,
          paineis: this.paineis.map(function (p) { return { p: p, hidden: p.hidden, curto: p.classList.contains('is-curto') }; }),
          abertos: this.itens.map(function (it) { return it.d.open; }),
          abas: this.barra ? lista(this.barra.querySelectorAll('[data-faq-aba]')).map(function (a) { return { a: a, sel: a.getAttribute('aria-selected') }; }) : []
        };
        // enquanto busca nenhuma aba fica escolhida, tambem para o leitor de tela
        this.estado.abas.forEach(function (x) { if (x.sel !== null) x.a.setAttribute('aria-selected', 'false'); });
        this.faq.classList.add('is-buscando');
        this.paineis.forEach(function (p) { p.classList.remove('is-curto'); });
      }

      desfazer(it) {
        it.texto.textContent = it.titulo;
        var marcas = it.resp.querySelectorAll('[data-faq-marca]');
        if (marcas.length) {
          lista(marcas).forEach(function (m) { m.parentNode.replaceChild(document.createTextNode(m.textContent), m); });
          it.resp.normalize();
        }
        it.d.hidden = false;
      }

      // poe os itens na ordem dada (appendChild move o no); na saida volta a ordem original, que o corte do
      // "ver todas" (nth-child) usa
      ordenar(itens) {
        itens.forEach(function (it) { it.lista.appendChild(it.d); });
      }

      filtrar(termos) {
        var total = 0;
        var comResultado = [];
        var ativo = this.estado.ativo;
        var noTopo = [];
        var depois = [];
        var fora = [];
        this.itens.forEach(function (it) {
          this.desfazer(it);
          var bate = termos.every(function (t) { return it.tituloN.indexOf(t) > -1 || it.respN.indexOf(t) > -1; });
          it.d.hidden = !bate;
          if (!bate) { fora.push(it); return; }
          total++;
          if (comResultado.indexOf(it.painel) < 0) comResultado.push(it.painel);
          var noTitulo = marcar(it.texto.firstChild, termos);
          // texto de link fica sem marca: o link pinta a letra pelo fundo e a marca sumiria com a palavra
          nosDeTexto(it.resp).forEach(function (n) { if (!n.parentElement.closest('a')) marcar(n, termos); });
          // achou na pergunta: sobe para o topo do grupo; so na resposta: vem depois, com o trecho embaixo
          if (noTitulo) noTopo.push(it);
          else {
            depois.push(it);
            var t = trecho(it.respTxt, termos);
            if (t) it.texto.appendChild(t);
          }
          // pergunta da outra aba: selo pequeno com o nome do grupo
          if (ativo && it.painel !== ativo) {
            var rotulo = this.rotulos[this.paineis.indexOf(it.painel)];
            if (rotulo) {
              var selo = document.createElement('span');
              selo.className = 's-faq__selo-grupo';
              selo.setAttribute('data-faq-extra', '');
              selo.textContent = rotulo;
              it.texto.insertBefore(selo, it.texto.firstChild);
            }
          }
        }, this);
        this.ordenar(noTopo.concat(depois, fora));
        this.paineis.forEach(function (p) { p.hidden = comResultado.indexOf(p) < 0; });
        if (this.vazio) this.vazio.hidden = total > 0;
        if (!total && this.termoVazio) this.termoVazio.textContent = this.campo.value.trim();
        this.contar(total);
      }

      // devolve tudo como estava antes da busca
      sair() {
        if (this.vazio) this.vazio.hidden = true;
        var e = this.estado;
        if (!e) return;
        this.estado = null;
        this.itens.forEach(this.desfazer, this);
        this.ordenar(this.itens);
        e.paineis.forEach(function (x) {
          x.p.hidden = x.hidden;
          x.p.classList.toggle('is-curto', x.curto);
        });
        // fecha antes de abrir: com "uma por vez" abrir uma fecha a outra do mesmo grupo
        this.itens.forEach(function (it, i) { if (!e.abertos[i]) it.d.open = false; });
        this.itens.forEach(function (it, i) { if (e.abertos[i]) it.d.open = true; });
        e.abas.forEach(function (x) { if (x.sel !== null) x.a.setAttribute('aria-selected', x.sel); });
        this.faq.classList.remove('is-buscando');
        this.contar(null);
      }

      contar(n) {
        clearTimeout(this.ta);
        var linha = this.linha;
        if (linha) linha.textContent = '';
        if (n === null) {
          if (this.aviso) this.aviso.textContent = '';
          return;
        }
        var d = this.dataset;
        var txt = n === 0 ? d.vazio : n === 1 ? d.uma : (d.contagem || '').replace('{n}', n);
        // na linha visivel o numero vira etiqueta; sem resultado a linha some (o cartao de vazio ja fala)
        if (linha && n > 0 && txt) {
          var num = String(n);
          var i = txt.indexOf(num);
          if (i > -1) {
            var forte = document.createElement('strong');
            forte.textContent = num;
            linha.appendChild(document.createTextNode(txt.slice(0, i)));
            linha.appendChild(forte);
            linha.appendChild(document.createTextNode(txt.slice(i + num.length)));
          } else {
            linha.textContent = txt;
          }
        }
        if (this.aviso) {
          var aviso = this.aviso;
          this.ta = setTimeout(function () { aviso.textContent = txt || ''; }, AVISO);
        }
      }
    }
  );
})();
